import { ButtonBar, FilterButtons, useIsFilterModified } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useCallback, useState } from 'react';
import HistoryLogFilterPopOut from '@/seller/components/HistoryLog/HistoryLogFilterPopOut';
import HistoryLogTable from '@/seller/components/HistoryLog/HistoryLogTable';
import { HistorySearchFilters } from '@/services/object-history-log';
import theme from './ProjectHistoryLog.module.scss';

interface ProjectHistoryLogProps {
    projectId: number;
}

const ProjectHistoryLog = ({ projectId }: ProjectHistoryLogProps) => {
    const [filterPopUpIsOpen, setFilterPopUpIsOpen] = useState(false);
    const getDefaultFilter = useCallback((): HistorySearchFilters => {
        return {
            projectId,
            objectType: 'Project',
        };
    }, [projectId]);

    const [filter, setFilter] = useState<HistorySearchFilters>(getDefaultFilter());
    const filterModified = useIsFilterModified(filter, getDefaultFilter);

    return (
        <>
            <ButtonBar className={theme.buttonBar}>
                <ButtonBar.Right>
                    <FilterButtons onButtonClick={() => setFilterPopUpIsOpen(true)} isActive={filterModified} />
                </ButtonBar.Right>
            </ButtonBar>
            <div className={theme.wrapper}>
                <HistoryLogTable filter={filter} />
            </div>
            <HistoryLogFilterPopOut
                onChange={setFilter}
                filter={filter}
                toggle={() => {
                    setFilterPopUpIsOpen(false);
                }}
                show={filterPopUpIsOpen}
            />
        </>
    );
};
export default ProjectHistoryLog;
